import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-markdown',
  templateUrl: './custom-markdown.component.html',
  styleUrls: ['./custom-markdown.component.scss'],
})
export class CustomMarkdownComponent {
  @Input() data = '';
}
